import { CommonModule } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { MatIcon } from '@angular/material/icon';
import { Router } from '@angular/router';
import { MenuItem } from '../../../../../interfaces/menuItem';
import { NavigationService } from '../../../../../services/navigation.service';
import { AuthService } from '../../../../../services/auth.service';

@Component({
	selector: 'app-sidebar-items',
	standalone: true,
	imports: [MatIcon, CommonModule],
	templateUrl: './sidebar-items.component.html',
	styleUrl: './sidebar-items.component.scss'
})
export class SidebarItemsComponent implements OnInit {
	selectedMenuOptionId: number = 1;
	expandedItems = new Set<number>();

	@Input() setBackground: boolean = true;
	@Input() menuItems: MenuItem[] = [
		{ id: 1, icon: 'dashboard', title: 'Dashboard', url: 'dashboard' },
		{ id: 2, icon: 'bar_chart', title: 'Estadísticas', url: 'stats' },
		{ id: 3, icon: 'folder_special', title: 'Reportes', url: 'reports' },
		{ id: 4, icon: 'sensor_occupied', title: 'Modo Prueba', url: 'test' },
		{ id: 5, icon: 'add_link', title: 'Link App Camara', url: 'app-link' },
		{ id: 6, icon: 'photo_camera', title: 'Operaciones OBD', url: 'operations' },
		{
			id: 7,
			icon: 'settings',
			title: 'Configuración',
			children: [
				{ id: 71, icon: '', title: 'Parámetros', url: 'settings/parameters' },
				{ id: 72, icon: '', title: 'Plantillas', url: 'settings/templates' }
			]
		},
		{ id: 8, icon: 'edit', title: 'Editar mi perfil', url: 'edit' },
		{ id: 9, icon: 'logout', title: 'Cerrar sesión', url: 'login' }
	];

	constructor(
		private _navigationService: NavigationService,
		private _authService: AuthService,
		private _router: Router
	) {}

	ngOnInit(): void {
		if (this._authService.isUserMinion()) {
			const adminRoutesId: number[] = [1, 2, 3, 7, 8];
			this.menuItems = this.menuItems.filter(
				(menuItem) => !adminRoutesId.includes(menuItem.id)
			);
		}
	}

	navigateTo(navItem: MenuItem): void {
		if (navItem.url === '') return;
		this.selectedMenuOptionId = navItem.id;
		this._router.navigate([navItem.url]);
		this._navigationService.emitNextRoute(navItem.title, navItem.id);
	}

	toggleOrNavigate(navItem: MenuItem): void {
		if (navItem.children) {
			if (this.expandedItems.has(navItem.id)) {
				this.expandedItems.delete(navItem.id);
			} else {
				this.expandedItems.add(navItem.id);
			}
		} else {
			this.navigateTo(navItem);
		}
	}
}
